import { createElement, useRef, useState } from 'react';
import { Pagination as OriginalPagination } from '@alifd/next';
import './index.scss';
const Pagination = (props) => {
    const [pageSize, setPageSize] = useState(10);
    const pageSizeRef = useRef(10);
    const pageRef = useRef(1);
    const onPageSizeChange = (pageSize) => {
        pageSizeRef.current = pageSize;
        setPageSize(pageSize);
        onChange();
    };
    const onPageChange = (pageNo) => {
        pageRef.current = pageNo;
        onChange();
    };
    const onChange = () => {
        props?.onChange({
            pageSize: pageSizeRef.current,
            pageNo: pageRef.current,
        });
    };
    return (createElement("div", { className: "pagination-group" },
        createElement(OriginalPagination, { pageSizeSelector: "dropdown", pageSizePosition: "start", onPageSizeChange: onPageSizeChange, onChange: onPageChange, total: props?.total, pageSizeList: [5, 10, 20, 50, 100], totalRender: (total) => createElement("span", { style: { marginLeft: 20 } }, `共 ${total} 条`), pageSize: pageSize })));
};
export default Pagination;
